module.exports = __webpack_public_path__ + "static/media/IMG-20221018-WA0002.de0fed1f.jpg";